import _ from 'lodash';
import React, { useState } from 'react';
import { Button, Divider, Grid, GridColumn, Header, Icon, Menu, Modal, Segment, Table, TableBody, TableHeader, TableHeaderCell, TableRow, TableCell, Input } from 'semantic-ui-react';
import { Rnd } from 'react-rnd';
import { htmlToText } from 'html-to-text';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Stopwatch from '../../Timers/Stopwatch';
import Countdown from '../../Timers/Countdown';
import { Consts, Styles, Theme } from '../../../../res';
import { Calculator, FlexWindow, SpreadsheetEditor } from '../../..';
import { getQuestionTypeString } from '../../../../helpers/examHelpers';
import FreeModal from '../FreeModal';
import stringShorten from '../../../../helpers/stringShorten';

const { noExtraSpaces, f_10_400_text } = Styles;

const ExamHeader = (props) => {
    const { Q, questions, onGoingExam, userOnFinishExam, examFinishingLoading,
        onSelectQuestion, onFlagQuestion, onFavQuestion, Qindex, FactIndex,
        isMockExam, theme, isViewOnly } = props;

    const mockPartNumber = onGoingExam?.orderNum || 0;
    const [showFinishConfirm, setShowFinishConfirm] = useState(false);
    const [showCalculator, setShowCalculator] = useState(false);
    const [showSheet, setShowSheet] = useState(false);
    const [sheetData, setSheetData] = useState(null);
    const [showOverview, setShowOverView] = useState(false);
    const course = useSelector(state => state?.userCourses?.selectedCourse);
    const { t } = useTranslation();

    const renderTestLetsHeader = () => {

        if (isMockExam)
            return (<Menu borderless style={{ ...noExtraSpaces, backgroundColor: "#043a4e", borderRadius: 0 }}>
                <Menu.Item style={{ color: Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    {course?.name}
                </Menu.Item>

                <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' active={mockPartNumber === 1} style={{ backgroundColor: mockPartNumber === 1 ? Theme.colors.WHITE : Theme.colors.CPA_NAVY, color: mockPartNumber === 1 ? Theme.colors.CPA_ORANGE : Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    <Icon name={mockPartNumber === 1 ? 'map marker alternate' : mockPartNumber > 1 ? 'check' : 'lock'} />
                    {t('TestLet', { letNumber: 1 })}
                </Menu.Item>
                <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' active={mockPartNumber === 2} style={{ backgroundColor: mockPartNumber === 2 ? Theme.colors.WHITE : Theme.colors.CPA_NAVY, color: mockPartNumber === 2 ? Theme.colors.CPA_ORANGE : Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    <Icon name={mockPartNumber === 2 ? 'map marker alternate' : mockPartNumber > 2 ? 'check' : 'lock'} />
                    {t('TestLet', { letNumber: 2 })}
                </Menu.Item>
                <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' active={mockPartNumber === 3} style={{ backgroundColor: mockPartNumber === 3 ? Theme.colors.WHITE : Theme.colors.CPA_NAVY, color: mockPartNumber === 3 ? Theme.colors.CPA_ORANGE : Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    <Icon name={mockPartNumber === 3 ? 'map marker alternate' : mockPartNumber > 3 ? 'check' : 'lock'} />
                    {t('TestLet', { letNumber: 3 })}
                </Menu.Item>
                <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' active={mockPartNumber === 4} style={{ backgroundColor: mockPartNumber === 4 ? Theme.colors.WHITE : Theme.colors.CPA_NAVY, color: mockPartNumber === 4 ? Theme.colors.CPA_ORANGE : Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    <Icon name={mockPartNumber === 4 ? 'map marker alternate' : mockPartNumber > 4 ? 'check' : 'lock'} />
                    {t('TestLet', { letNumber: 4 })}
                </Menu.Item>
                <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' active={mockPartNumber === 5} style={{ backgroundColor: mockPartNumber === 5 ? Theme.colors.WHITE : Theme.colors.CPA_NAVY, color: mockPartNumber === 5 ? Theme.colors.CPA_ORANGE : Theme.colors.WHITE, fontSize: f_10_400_text }}>
                    <Icon name={mockPartNumber === 5 ? 'map marker alternate' : mockPartNumber > 5 ? 'check' : 'lock'} />
                    {t('TestLet', { letNumber: 5 })}
                </Menu.Item>
            </Menu>
            );

        return (<Menu borderless style={{ ...noExtraSpaces, backgroundColor: "#043a4e", borderRadius: 0 }}>
            <Menu.Item style={{ color: Theme.colors.WHITE, fontSize: f_10_400_text }}>
                {getQuestionTypeString(Q.questionTypeId)}
            </Menu.Item>
            <Menu.Item className='tw-border-s-2 tw-border-[#d5440b]' style={{ color: Theme.colors.WHITE, fontSize: f_10_400_text }}>
                {course?.name}
            </Menu.Item>
        </Menu>
        );
    };
    const renderTimer = () => {

        if (onGoingExam.isViewOnly)
            return <Header as='h2' color='red' textAlign='center'>{t('ViewOnly')}</Header>;

        return (
            <>
                {isMockExam ?
                    <Countdown
                        expiryTimestamp={onGoingExam.remainTime}
                        onExpire={() => userOnFinishExam(onGoingExam)}
                        theme={theme}
                    />
                    : <Stopwatch
                        offsetTimestamp={new Date(new Date().getTime() + (new Date().getTime() - new Date(onGoingExam.startDateTime).getTime()))}
                        theme={theme}
                        isAutoStart
                    />}

            </>
        );
    };
    const renderPrimaryHeader = () => {
        return (
            <div style={{ ...noExtraSpaces, paddingInline: 20, paddingTop: 6, borderBottom: `solid 1px ${Theme.colors.CPA_ORANGE}` }} >
                <Grid columns='equal' verticalAlign='middle' style={noExtraSpaces}>
                    <GridColumn style={noExtraSpaces}>
                        <div>
                            {renderTimer()}
                        </div>
                    </GridColumn>

                    <GridColumn style={noExtraSpaces}>
                        <div className='tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-5 tw-text-CPA_NAVY'>
                            <div onClick={() => setShowCalculator(p => !p)} className='tw-flex tw-flex-col tw-items-center tw-justify-center'>
                                <div><Icon link size='big' name='calculator' /></div>
                                <p>{t("Calculator")}</p>
                            </div>
                            <div onClick={() => setShowSheet(p => !p)} className='tw-flex tw-flex-col tw-items-center tw-justify-center'>
                                <div><Icon link size='big' name='table' /></div>
                                <p>{t("Spreadsheet")}</p>
                            </div>
                            <div onClick={() => setShowOverView(p => !p)} className='tw-flex tw-flex-col tw-items-center tw-justify-center'>
                                <div><Icon link size='big' name='list ol' /></div>
                                <p>{t("Overview")}</p>
                            </div>
                        </div>
                    </GridColumn>

                    <GridColumn style={noExtraSpaces} textAlign='right' >
                        <div>
                            <Button
                                style={{ borderRadius: 0, backgroundColor: Theme.colors.CPA_ORANGE, color: Theme.colors.WHITE }}
                                content={t(onGoingExam.isViewOnly ? 'Exit' : 'SubmitTestLet').toUpperCase()}
                                loading={examFinishingLoading}
                                onClick={() => onGoingExam.isViewOnly ? userOnFinishExam(onGoingExam) : setShowFinishConfirm(true)}
                            />

                            <Modal
                                size='small'
                                open={showFinishConfirm}
                                content={<div className='tw-border-s-2 tw-border-CPA_ORANGE tw-bg-WHITE'>
                                    <div className='tw-p-5'>
                                        <h1 className='tw-text-2xl'>{unAnsweredQuestions?.length ? t("CpaFinishExamHeader") : t("AreYouSureFinishExam")}</h1>
                                    </div>
                                    <Divider />
                                    {Boolean(unAnsweredQuestions?.length) && <div className='tw-p-5'>
                                        {
                                            unAnsweredQuestions.map((_, idx) => <p key={idx} className='tw-font-bold tw-text-CPA_NAVY tw-cursor-pointer' onClick={() => { onSelectQuestion(unAnsweredQuestions[idx]); setShowFinishConfirm(false); }}>{`${t("NavigateTo")}: ${unAnsweredQuestions?.[idx] && questions.findIndex(q => q.questionId === unAnsweredQuestions[idx].questionId) + 1}`}</p>)
                                        }
                                        <p>{t("CpaFinishExamText")}</p>
                                    </div>}

                                    <div className='tw-flex tw-flex-row tw-items-start tw-justify-between tw-bg-PRIMARY_05 tw-p-5'>
                                        <p className='tw-text-CPA_NAVY tw-underline tw-cursor-pointer' onClick={() => setShowFinishConfirm(false)}>{t("ReturnToTestlet")?.toUpperCase()}</p>
                                        <div>
                                            <Button
                                                style={{ borderRadius: 0, backgroundColor: Theme.colors.CPA_ORANGE, color: Theme.colors.WHITE }}
                                                onClick={() => {
                                                    userOnFinishExam(onGoingExam);
                                                    setShowFinishConfirm(false);
                                                }}
                                                content={t("SubmitTestLet")?.toUpperCase()}
                                            />
                                        </div>
                                    </div>

                                </div>}
                            />
                        </div>

                    </GridColumn>
                </Grid>
            </div>
        );
    };


    if (!Q) return null;

    const unAnsweredQuestions = questions.filter(q => (!q.isSubmited && !q.answerJson && !q.answerText && !q.answerOptionId));

    return (
        <Segment basic style={noExtraSpaces}>
            {renderTestLetsHeader()}
            {renderPrimaryHeader()}
            {showCalculator && <FlexWindow
                isVisible={showCalculator}
                onClose={() => setShowCalculator(false)}
                title={t("Calculator")}
            >
                <Calculator />
            </FlexWindow>}

            {showSheet && <div><FreeModal
                onClose={() => setShowSheet(false)}
                fileKey={"sheet"}
                title={t("Spreadsheet")}
                open={showSheet}
                headerColor={Theme.colors.CPA_NAVY}
                headerTextColor={Theme.colors.WHITE}
                isNeg={false}
                closeButton={{
                    content: t("Save&Close"),
                    style: {
                        color: Theme.colors.WHITE,
                        backgroundColor: Theme.colors.CPA_ORANGE,
                        borderRadius: 0
                    },
                    onClick: () => isViewOnly ? undefined : setSheetData(p => p)

                }}
                children={<SpreadsheetEditor data={{ value: sheetData, setValue: setSheetData }} onBlur={() => isViewOnly ? undefined : setSheetData(p => p)} readOnly={isViewOnly} />}
            /></div>}

            {showOverview && <Rnd
                default={{
                    x: (window.innerWidth - 600) / 2,
                    y: (window.innerHeight - 400) / 2,
                    width: 600,
                    height: 400,
                }}
                bounds="body"
                className='tw-z-[90]'
                enableResizing={false}
                disableDragging
            >
                <div className='tw-border tw-h-full tw-flex tw-flex-col tw-bg-white tw-border-CPA_NAVY'>
                    <div className='tw-bg-CPA_NAVY tw-px-2 tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-between'>
                        <p className='tw-text-WHITE tw-font-bold'>{t("Overview")}</p>
                        <div><Icon size='small' onClick={() => setShowOverView(false)} link name='delete' bordered className='tw-bg-CPA_ORANGE tw-text-WHITE' /></div>
                    </div>
                    <CpaOverView
                        Q={Q}
                        FactIndex={FactIndex}
                        Qindex={Qindex}
                        isMockExam={isMockExam}
                        questions={questions}
                        onSelectQuestion={onSelectQuestion}
                        onFlagQuestion={onFlagQuestion}
                        onFavQuestion={onFavQuestion}
                        onClose={() => setShowOverView(false)}
                    />
                </div>
            </Rnd>}
        </Segment>
    );
};


const CpaOverView = ({ onClose, questions, Qindex, onFlagQuestion, onFavQuestion, FactIndex, isMockExam, onSelectQuestion }) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const [term, setTerm] = useState("");
    const onChangeTerm = _.debounce(value => setTerm(value), 300, { trailing: true, leading: true });

    return (
        <div className='tw-overflow-y-auto tw-flex-1'>
            <Table compact='very' celled striped selectable>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell collapsing colSpan='1'><p className='tw-font-bold tw-text-CPA_ORANGE'>{t("Questions")}</p></TableHeaderCell>
                        <TableHeaderCell colSpan='2'>{<Input placeholder={t("Search")} fluid value={term} onChange={(e, { value }) => onChangeTerm(value)} />}</TableHeaderCell>
                    </TableRow>
                </TableHeader>


                <TableBody>
                    {
                        questions.filter(q => !term ? true : q.questionText?.toLowerCase()?.includes(term?.toLowerCase())).map((q, idx) => {

                            let text = stringShorten(htmlToText(q.questionText, { wordwrap: null }), 70);
                            const isAnswerd = q?.answerOptionId || q?.answerText || q?.answerJson;
                            const isSelected = idx === Qindex;
                            if (q.questionTypeId === Consts.QUESTIONS_TYPES.COMPOSITE) {
                                try {
                                    const contentJson = JSON.parse(q?.contentJson || "{}");
                                    if (contentJson?.[0]?.textAr || contentJson?.[0]?.textEn) {
                                        text = stringShorten(htmlToText(isArabic ? contentJson?.[0]?.textAr : contentJson?.[0]?.textEn, { wordwrap: null }), 70);
                                    }
                                } catch (error) {

                                }
                            }
                            return <TableRow className={isSelected && "tw-bg-CPA_ORANGE/20"} key={idx}>
                                <TableCell collapsing colSpan='1'>
                                    <div className='tw-flex tw-items-center tw-flex-row tw-gap-1'>
                                        <p style={{ fontWeight: (isSelected || !isAnswerd) && "bold", fontSize: (isSelected || !isAnswerd) && 20, color: isSelected ? Theme.colors.CPA_ORANGE : Theme.colors.CPA_NAVY }}>{q.factId ? FactIndex + 1 : idx + 1}</p>
                                        <Icon link name={q.isFlagged ? "bookmark" : "bookmark outline"} inverted style={{ color: 'maroon' }} onClick={() => onFlagQuestion(q)} />
                                        {!isMockExam && <Icon link name={q.isFav ? "star" : "star outline"} inverted style={{ color: 'maroon' }} onClick={() => onFavQuestion(q)} />}
                                    </div>
                                </TableCell>
                                <TableCell colSpan='2' className='tw-cursor-pointer' onClick={() => { onSelectQuestion(q); onClose(); }}>
                                    <p style={{ fontWeight: !isAnswerd && "bold" }}>{text}</p>
                                </TableCell>
                            </TableRow>;
                        })
                    }
                </TableBody>
            </Table>

        </div >
    );
};

export default ExamHeader;